import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        margin-right: ", ";\n        margin-bottom: ", ";\n\n        & > * {\n            margin-right: ", ";\n            margin-bottom: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { spacing } from './spacing';
export var gutter = function gutter(_ref) {
  var amount = _ref.spacing;
  var value = spacing(amount);
  var valueNegative = spacing(amount * -1);
  return css(_templateObject(), valueNegative, valueNegative, value, value);
};